<div class="hot-actions" *ngIf="showSomeUserBarIcons">
    <a [routerLink]="AppUrls.APPS_CREATE | appUrl" class="btn" id="createAppBtn" *ngIf="user.permissions.canCreateApps">
        <svg-image name="plus-round-filled"></svg-image>
        <span>{{ 'header.createAppBtn' | i18next }}</span>
    </a>

    <a
        [routerLink]="AppUrls.PAYOUTS | appUrl"
        [externalLink]="false"
        class="btn"
        id="userBalance"
        tooltip="{{ 'header.balanceTooltip' | i18next }}"
        *ngIf="user.permissions.canViewPayouts"
    >
        <svg-image name="usd-round-filled"></svg-image>
        <span>
            <span class="balance-value">{{ user?.availableBalance | numberFormat: 2 }}</span>
        </span>
    </a>
</div>

<notifications></notifications>

<button type="button" class="user-bar-toggle" (click)="onToggleBtnClick()">
    <svg-image name="user-round-filled"></svg-image>
    <i class="fa fa-caret-down"></i>
</button>

<div class="user-bar" [ngClass]="{visible: userBarVisible}">
    <div class="user-bar__item user-bar__item--menu-button">
        <div class="buttons-group">
            <a
                [routerLink]="AppUrls.PAYOUTS | appUrl"
                [externalLink]="false"
                class="btn balance"
                tooltip="{{ 'header.balanceTooltip' | i18next }}"
                *ngIf="user.permissions.canViewPayouts"
            >
                <svg-image name="usd-round-filled"></svg-image>
                <span class="balance-value">{{ user?.availableBalance | numberFormat: 2 }}</span>
            </a>
            <button type="button" class="user-bar-toggle" (click)="onDocClick()">
                <svg-image name="user-round-filled"></svg-image>
                <i class="fa fa-caret-up"></i>
            </button>
        </div>
    </div>

    <div class="user-bar__item">
        <div class="email-wrapper">{{ user.email }}</div>
    </div>

    <div class="user-bar__item user-bar__item--separate"></div>

    <div class="user-bar__item user-bar__item--language-switcher" *ngIf="!demo.isDemoHost">
        <language-switcher></language-switcher>
    </div>

    <ng-container *ngIf="demo.isAccountDemoOnly">
        <div class="user-bar__item user-bar__item--separate"></div>
        <div class="user-bar__item">
            <div finishDemo class="finish-demo__wrap">
                <a id="finish-demo-button">{{ 'header.userMenu.finishDemo' | i18next }}</a>
            </div>
        </div>
        <div class="user-bar__item user-bar__item--separate"></div>
    </ng-container>

    <div class="user-bar__item user-bar__item--switcher">
        <div class="switcher" [class.loading]="loading$ | async">
            <tumbler [ngModel]="switchColorTheme" (ngModelChange)="onValueChangesTheme($event)">
                {{ 'analytics.monetization.settings.switchColorTheme' | i18next }}
            </tumbler>
        </div>
    </div>

    <div class="user-bar__item user-bar__item--separate"></div>

    <div class="user-bar__item" (click)="signOut()">{{ 'header.userMenu.logout' | i18next }}</div>
</div>
